import { render, staticRenderFns } from "./RegisteredInterestDataTable.vue?vue&type=template&id=3b2114a2&scoped=true&"
import script from "./RegisteredInterestDataTable.vue?vue&type=script&lang=js&"
export * from "./RegisteredInterestDataTable.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredInterestDataTable.vue?vue&type=style&index=0&id=3b2114a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2114a2",
  null
  
)

export default component.exports